import { Button } from 'common/Components/Button';
import InputPin from 'common/Components/form/InputPin';
import { ChevronLeftIcon } from 'common/Icons';
import { handleProductType } from 'common/method/helper';
import { FC, useLayoutEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useGetCaptch, useRetrySms } from 'services/login';
import Captcha from 'common/Components/Captcha';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRouter } from 'common/hooks/useRouter';
import { Trans, useTranslation } from 'react-i18next';

/////////////////////need ///////////////////
//retryToken ,starredMessage , expireDate , ?temporaryToken from state in react-router
////////////////////////////////////////////

type IFormOtpType = {
  handleSubmitOtp: (data: ISubmitOtpModuleType) => void;
};

type formDataType = {
  captchaValue: string;
};

const FormOtp: FC<IFormOtpType> = ({ handleSubmitOtp }) => {
  //*global
  const {
    navigate,
    history: { state },
  } = useRouter();
  const { retryToken, starredMessage, expireDate, temporaryToken } =
    state || {};
  const [searchParams] = useSearchParams();

  const { t } = useTranslation();
  //*form
  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    setValue , 
    getValues
  } = useForm<formDataType>({
    defaultValues: {
      captchaValue: '',
    },
    mode: 'onChange',
  });
  //*otp state
  const [otp, setOtp] = useState<string>('');
  //*handle captch
  const { data: captcha, refetch: refetchCaptcha } = useGetCaptch();

  const refetchCaptchaMethod = () => {
    refetchCaptcha();
    resetField('captchaValue');
  };

  const handleNavigate = (result: any) => {
    let retryTokenVar = '';
    let starredMessageVar = '';
    let expireDateVar = '';
    let temporaryTokenVar = '';
    if (result.riModel) {
      const {
        riModel: {
          retryToken,
          starredMessage,
          expireDate,
          userIdentity: { token },
        },
      } = result;
      retryTokenVar = retryToken;
      starredMessageVar = starredMessage;
      expireDateVar = expireDate;
      temporaryTokenVar = token;
    } else if (result.fpDto) {
      const {
        fpDto: {
          result: { retryToken, starredMessage, expireDate },
        },
      } = result;
      retryTokenVar = retryToken;
      starredMessageVar = starredMessage;
      expireDateVar = expireDate;
    }

    navigate.pushHere({
      state: {
        ...state,
        retryToken: retryTokenVar,
        starredMessage: starredMessageVar,
        expireDate: expireDateVar,
        temporaryToken: temporaryTokenVar,
      },
      replace: true,
    });
  };

  //*RetrySms
  const { mutate: mutateRetrySms } = useRetrySms({
    onSuccess: (data) => {
      if (data.succeeded) {
        handleNavigate(data.result);
      } else {
        if (data?.errors && data?.errors[0] === 'InvalidToken') {
          navigate.pushLogin();
        }
      }
    },
  });

  const SendCodeAgain = () => {
    setOtp('');
    mutateRetrySms({
      token: retryToken,
    });
  };

  const onSubmit: SubmitHandler<formDataType> = (data) => {
    const otpRes = otp.replaceAll(' ', '').replaceAll('_', '');
    if (!captcha?.key) {
      refetchCaptchaMethod();
      return;
    }
    if (!retryToken) {
      navigate.pushLogin();
      return;
    }
    if (otpRes.length !== 6) {
      refetchCaptchaMethod();
      toast.warning(t('Errors.OtpIsNotValid'));
      return;
    }

    sessionStorage.setItem('otp', JSON.stringify(otpRes));

    const res: ISubmitOtpModuleType = {
      otp: otpRes,
      captchaValue: data.captchaValue,
      captchaKey: captcha.key,
      productType: handleProductType(searchParams),
      token: temporaryToken,
    };
    setTimeout(() => {
      refetchCaptchaMethod();
    }, 500);
    handleSubmitOtp(res);
  };

  useLayoutEffect(() => {
    if (!retryToken) {
      toast.error('لطفا دوباره ورود کنید');
      navigate.pushLogin();
    }
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="text-center pr-5">
        <h1 className="text-5xl pt-4">{t(`FormSide.ValidationCodeText`)}</h1>
        <p className=" pt-4 text-right text-L-gray-250 text-xl font-medium">
          <Trans
            i18nKey={`FormSide.Input.OTP.Placeholder`}
            values={{
              n: starredMessage,
            }}
            components={{ tag: <span className="inline-block ltr p-1" /> }}
          />
        </p>
      </div>

      <div className="p-4">
        <InputPin
          sendCodeAgain={SendCodeAgain}
          value={otp}
          onChange={setOtp}
          expireDate={expireDate}
        />
      </div>

      <div className="m-4">
        <Captcha
          register={register}
          errors={errors}
          captcha={captcha}
          onRefresh={refetchCaptchaMethod}
          setValue={setValue}
          getValues={getValues}
        />
      </div>

      <div className="mt-8 md:mt-12 p-4 text-center">
        <Button className="bg-L-primary-50 text-white w-full p-2 rounded text-3xl">
          {t(`FormSide.NextStepButton`)}
          <ChevronLeftIcon className="inline mr-4" />
        </Button>

        <Button
          onClick={(e)=>{
            e.preventDefault();
            navigate.back()
          }}
          className="text-L-gray-300 w-full p-2 rounded mt-4 text-3xl"
        >
          {t(`FormSide.CancelText`)}
        </Button>
      </div>
    </form>
  );
};

export default FormOtp;
